module.exports = __webpack_public_path__ + "img/logo_parking.c16d00eb.png";